export default function () {
  var gallery = $('[data-fancybox="group"]')
  $('.js--fancybox').on('click', function (e) {
    e.preventDefault()
    $.fancybox.open(gallery)
  })
}
